<template>
  <div>
    <List
      url="/app_alarms/"
      :title="title"
      titleClass="title"
      :size="size"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :update="updateList"
      :operat="operat"
      :MultipleSel="true"
      :is_admin="is_admin"
      @deletedata="deletedata"
    >
      <div slot="Filter" style="display: block;">
        <div class="item">
          <label>告警等级：</label>
          <el-checkbox-group v-model="level">
            <el-checkbox
              v-for="alarmlevel in alarmlevels.slice(1, 6)"
              :label="alarmlevel.ID"
              :key="alarmlevel.ID"
              :value="alarmlevel.ID"
            >{{ alarmlevel.Name }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="item">
          <label style="margin-left:0.5%">SIP账号：</label>
          <el-input
            v-model="searchData.account"
            placeholder="SIP账号"
          ></el-input>
          <label>网关地址：</label>
          <el-input
            v-model="searchData.gate_server"
            placeholder="网关地址"
          ></el-input>
          <label style="margin-left:2.3%">API：</label>
          <el-input
            v-model="searchData.alarm_api"
            placeholder="API"
          ></el-input>
          <label>手机型号：</label>
          <el-input
            v-model="searchData.vender"
            placeholder="手机型号"
          ></el-input>
        </div>
        <div class="item">
          <label>操作系统：</label>
          <el-input
            v-model="searchData.os"
            placeholder="操作系统"
          ></el-input>

          <label>系统版本：</label>
          <el-input
            v-model="searchData.os_ver"
            placeholder="系统版本"
          ></el-input>
          <label>APP名称：</label>
          <el-input
            v-model="searchData.app"
            placeholder="APP名称"
          ></el-input>
          <label>APP版本：</label>
          <el-input
            v-model="searchData.app_ver"
            placeholder="APP版本"
          ></el-input>
        </div>
        <div class="item">
          <label>告警信息：</label>
          <el-input
            v-model="searchData.alarm_msg"
            placeholder="告警信息"
          ></el-input>
          <label style="margin-left:1%">告警码：</label>
          <el-input
            v-model="searchData.alarm_code"
            placeholder="告警码"
          ></el-input>
          <label style="margin:5px 0px;">发生时间：</label>
          <el-date-picker
            style="width:150px;margin:0px;"
            v-model="searchData.begin_time"
            type="date"
            placeholder="开始时间"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <label>—</label>
          <el-date-picker
            style="width:160px;"
            v-model="searchData.end_time"
            type="date"
            placeholder="结束时间"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <el-button @click="search" type="primary">搜索</el-button>
        </div>
      </div>
      <template slot="Fresh">
        <div style=" margin-bottom:10px;float: right;vertical-align:middle;">
          <el-button @click="downloadByPeople()" type="primary" style="margin-right:20px">导出</el-button>
          <el-radio-group v-model="size" size="small">
            <el-radio-button label="medium">大</el-radio-button>
            <el-radio-button label="small">中</el-radio-button>
            <el-radio-button label="mini">小</el-radio-button>
          </el-radio-group>
          <br />
          <label style="margin:5px 5px;font-size:10px;color:red">最多只能导出5000条</label>
        </div>
      </template>
      <template slot="alarm_msg">
              <div style="display: flex;line-height:30px; ">
          <label>操作：</label>
          <el-checkbox-group v-model="action" style="margin-right:165px">
            <el-checkbox
              v-for="operat in operats"
              :label="operat"
              :key="operat"
              :value="operat"
              >{{ operat.Name }}
            </el-checkbox>
          </el-checkbox-group>
          <el-button @click="search" type="primary" size="small"
            >搜索</el-button
          >
        </div></template>
    </List>
    <DownloadBox
      :macdata="macdata"
      v-if="downloadBlock"
      @close="downloadClose"
      @update="updateList++"
    ></DownloadBox>
  </div>
</template>
<script>
import List from "../components/common/List.vue";
import DownloadBox from "../components/AlarmRecord/DownloadBox.vue";
import CsvExportor from 'csv-exportor';
import { alarmlevelsList } from "../components/Index/data.js";
import { Alarmlevels } from "../components/Index/data.js";

export default {
  components: {
    List,
    DownloadBox
  },
  data() {
    return {
      tanle: [
        { name: "created", label: "告警时间" },
        { name: "levelName", label: "告警等级", status: "alarmLevel" },
        { name: "account", label: "SIP 账号" },
        { name: "alarm_code", label: "错误码" },
        { name: "alarm_name", label: "告警名称" },
        { name: "gate_server", label: "网关地址" },
        { name: "server_ip", label: "服务器IP" },
        { name: "client_ip", label: "客户端IP" },
        { name: "vender", label: "手机型号" },
        { name: "os", label: "操作系统" },
        { name: "os_ver", label: "系统版本" },
        { name: "app", label: "APP名称" },
        { name: "app_ver", label: "APP版本" },
        { name: "alarm_api", label: "API" },
        { name: "alarm_msg", label: "告警信息",status: "alarmEvent" }
      ],
      searchData: {
        level: "",
        account: "",
        gate_server: "",
        begin_time: "",
        end_time: "",
        alarm_api: "",
        vender: "",
        os: "",
        os_ver: "",
        app: "",
        app_ver: "",
        alarm_code: "",
        alarm_msg: ""
      },
      level: [],
      device_type: [],
      cloud: [],
      alarm_status: [],
      operat: [
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],
      updateList: 0,
      alarmlevels: alarmlevelsList,
      title: "APP告警记录列表",
      size: "small",
      updateBlock: false,
      downloadBlock: false,
      updateForm: {},
      is_admin: false,
      macdata: ""
    };
  },
  mounted() {
    this.searchData.begin_time = this.changeToday(
      new Date()
    );
    this.is_admin = JSON.parse(localStorage.getItem("is_admin"));
    this.searchData.end_time = this.changeToday(new Date());
    // window.setInterval(() => { setTimeout(this.search(), 0); }, 120000);  // 自动刷新数据
  },
  methods: {
    dealList(data) {
      for (let i in data) {
        data[i].levelName = Alarmlevels[data[i].level];
      }
      return data;
    },
    deletedata(val) {
      let url = "app_alarms/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    download(val) {
      this.downloadBlock = true;
      this.updateForm = Object.assign({}, val);
      this.macdata = val;
    },
    updateClose() {
      this.updateBlock = false;
    },
    downloadClose() {
      this.downloadBlock = false;
    },
    search() {
      this.searchData.level = this.level.join(",");
      this.updateList++;
    },
    changeToday(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      return nowYear + "-" + nowMonth + "-" + nowDay;
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    //添加导出函数
    downloadByPeople() {
      let formData = [];
      formData = this.searchData;
      this.$http.get("app_alarms/", {
          created: formData.level,
          levelName: formData.levelName,
          account: formData.account,
          alarm_code: formData.alarm_code,
          alarm_name: formData.alarm_name,
          gate_server: formData.gate_server,
          server_ip: formData.server_ip,
          client_ip: formData.client_ip,
          venter: formData.venter,
          os: formData.os,
          os_ver: formData.os_ver,
          app: formData.app,
          app_ver: formData.app_ver,
          alarm_api: formData.app_api,
          app_msg: formData.app_msg
      }, (data) => {
        let heads = ['告警时间', '告警等级', 'SI账号', '错误码', '告警名称', '网关地址', '服务器IP', '客户端IP', '手机型号', '操作系统', '系统版本', 'APP名称', 'APP版本', 'API', '告警信息'];
        let csvData = [];
        let importData = data.data.results;
        let importDataLength;
        importDataLength = importData.length > 5000 ? 5000 : importData.length;
        for (let i = 0; i < importDataLength; i++) {
          let obj = importData[i];
          switch (obj.level) {
            case 0:
              obj.level = "未分类";
              break;
            case 1:
              obj.level = "灾难";
              break;
            case 2:
              obj.level = "严重";
              break;
            case 3:
              obj.level = "一般";
              break;
            case 4:
              obj.level = "警告";
              break;
            case 5:
              obj.level = "信息";
              break;
          }
            csvData.push({
              [heads[0]]: obj.created,
              [heads[1]]: obj.level,
              [heads[2]]: obj.account,
              [heads[3]]: obj.alarm_code,
              [heads[4]]: obj.alarm_name,
              [heads[5]]: obj.gate_server,
              [heads[6]]: obj.server_ip,
              [heads[7]]: obj.client_ip,
              [heads[8]]: obj.vender,
              [heads[9]]: obj.os,
              [heads[10]]: obj.os_ver,
              [heads[11]]: obj.app,
              [heads[12]]: obj.app_ver,
              [heads[13]]: obj.alarm_api,
              [heads[14]]: obj.alarm_msg
            })
        }

        CsvExportor.downloadCsv(
          csvData,
          { header: heads },
            'APP告警记录.csv'
        )

      });


    },
  }
};
</script>
<style scoped>
.item {
  display: flex;
  margin: 10px 0px;
  margin-right: 15px;
  line-height: 27px;
}
.size[data-v-771368fc]{
  margin: 0;
}
.el-input{
    width:160px;
    margin:0px 35px 0px 0px;
}
.el-tooltip__popper.is-dark{
  width: 200px;
}
</style>
